module.exports = __webpack_public_path__ + "static/media/cricular_add.4bb9f62a.svg";